import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const EntityConfigContext = createContext({
  entity_size: 'Generic',
  bee_sector: 'General Codes of Good Practice (incl May 2019 Amendments)',
  loading: true,
  refreshConfig: () => {}
});

export const EntityConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    entity_size: 'Generic',
    bee_sector: 'General Codes of Good Practice (incl May 2019 Amendments)',
    loading: true,
  });

  const fetchConfig = () => {
    if (!localStorage.getItem('access_token')) {
      setConfig(prev => ({...prev, loading: false }));
      return
    }
    api.get('/core/company-info/entity-config/')
    .then(res => setConfig({...res.data, loading: false }))
    .catch(() => setConfig(prev => ({...prev, loading: false})));
  };

  useEffect(() => { fetchConfig(); }, []);

  return (
    <EntityConfigContext.Provider value={{...config, refreshConfig: fetchConfig }}>
      {children}
    </EntityConfigContext.Provider>
  );
};

export const useEntityConfig = () => useContext(EntityConfigContext);
